import { useState } from 'react';
import {
  TextField, Tab, Tabs, Tooltip, Typography, AccordionSummary, AccordionDetails,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { ExpandMore } from '@mui/icons-material';
import { MultiselectFocus } from '../MultiselectFocus/index';
import { MultiselectLanguages } from '../MultiselectLanguages/index';
import { AccordionSummaryBox } from './AccordionSummaryBox';
import { ClearAllFilters } from './ClearAllFilters';
import { MobileFilterBox } from './MobileFilterBox';
import { StyledAutocomplete } from './StyledAutocomplete';
import { TabPanel } from './TabPanel';
import { TabsBox } from './TabsBox';

// this is the component
export default function FilterTabs({
  filter,
  setFilter,
  handleFilterChange,
  readerNames,
  focalPoints,
  readerLocations,
  languages,
  resetFilter,
}) {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <MobileFilterBox>
      <AccordionSummaryBox>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="h5">Filter</Typography>
        </AccordionSummary>
        <Tooltip title="alle Filter zurücksetzen">
          <ClearAllFilters onClick={resetFilter} className="clear" />
        </Tooltip>
      </AccordionSummaryBox>
      <AccordionDetails>
        <TabsBox>
          <Tabs value={value} onChange={handleChange}>
            <Tab label="Name" />
            <Tab label="Schwerpunkte" />
            <Tab label="Standort" />
            <Tab label="Sprachen" />
          </Tabs>
        </TabsBox>
        <TabPanel value={value} index={0}>
          <StyledAutocomplete
            fullWidth
            clearIcon={<ClearIcon fontSize="small" data-id="name" />}
            ListboxProps={{ 'data-id': 'name' }}
            componentsProps={{
              'input#:r1:': {
                'data-id': 'name',
              },
            }}
            onChange={handleFilterChange}
            options={readerNames}
            popupIcon={<SearchIcon />}
            renderInput={(params) => <TextField {...params} label="nach Reader suchen" />}
            value={filter.name ? filter.name : null}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <MultiselectFocus
            fullWidth
            focalPoints={focalPoints}
            filter={filter}
            setFilter={setFilter}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <StyledAutocomplete
            clearIcon={<ClearIcon fontSize="small" data-id="location" />}
            ListboxProps={{ 'data-id': 'location' }}
            onChange={handleFilterChange}
            options={readerLocations}
            popupIcon={<SearchIcon />}
            renderInput={(params) => <TextField {...params} label="Standorte" />}
            value={filter.location ? filter.location : null}
          />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <MultiselectLanguages
            fullWidth
            languages={languages}
            filter={filter}
            setFilter={setFilter}
          />
        </TabPanel>
      </AccordionDetails>
    </MobileFilterBox>
  );
}
